import React, {useEffect, useMemo, useState} from "react";
import {ColumnsType} from "antd/lib/table";
import {NewOrderTableData} from "../../../../../../models/orders/orders-list/order";
import {columnsFactory} from "./agent.data.invoices.new.order-table.columns";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {Table} from "antd";
import {ordersListService} from "../../../../../../services/orders/orders-list/orders.list.service";
import {TableRowSelection} from "antd/es/table/interface";
import {DispatchType} from "../../../../../../models/documents/invoices/invoice";

interface AgentDataInvoicesNewOrderTableProps {
    accountId: number;
    onChange?: (values: number[]) => void;
    value?: number[];
    changeUsedThirdPartyWarehouses: (value: boolean, defaultDispatchType: DispatchType) => void;
}

export const AgentDataInvoicesNewOrderTable: React.FC<AgentDataInvoicesNewOrderTableProps> = ({accountId, onChange, value, changeUsedThirdPartyWarehouses}) => {

    const t = useTranslate();

    const [orders, setOrders] = useState<NewOrderTableData[]>([]);

    const columns: ColumnsType<NewOrderTableData> = useMemo(() => columnsFactory(orders, t), [orders])

    const [loading, setLoading] = useState<boolean>(false);

    const [defaultDispatchType, setDefaultDispatchType] = useState<DispatchType>(DispatchType.DIRECT);

    const rowSelection: TableRowSelection<NewOrderTableData> = {
        type: "checkbox",
        selectedRowKeys: value || [],
        onChange: (selectedRowKeys: React.Key[], selectedRows: NewOrderTableData[]) => {
            onChange && onChange(selectedRowKeys as number[]);
            changeUsedThirdPartyWarehouses(selectedRows.some(obj => obj.thirdPartyWarehouse), defaultDispatchType);
        }
    }

    useEffect(() => {
        setLoading(true);
        ordersListService.getAllNewOrders(accountId).then(result => {
            setOrders(result.orders.map<NewOrderTableData>(v => {
                let doc = null;
                const docs = v.documents?.proforma;
                if (docs) {
                    doc = docs[0];
                }
                return {
                    ...v,
                    receiverDetails: (() => {
                        const fields = [];
                        if (v.receiver.name) {
                            fields.push(v.receiver.name)
                        }
                        fields.push(v.receiver.companyName, v.receiver.address)
                        return fields.join(", ")
                    })(),
                    fpes: "FPES-0" + (doc?.docNumber.split("-")[1] || ""),
                    joinedComments: v.comments.join(", ")
                }
            }));
            setLoading(false);
            changeUsedThirdPartyWarehouses(result.orders.some(obj => obj.thirdPartyWarehouse), result.defaultDispatchType);
            setDefaultDispatchType(result.defaultDispatchType);
        });
    }, [accountId])

    return (
        <>
            <Table
                loading={loading}
                columns={columns}
                dataSource={orders}
                pagination={false}
                rowKey={"id"}
                rowSelection={rowSelection}
            />
        </>
    );
}